import { NextFetchRequestInit } from '@/app/types';

export const createNextFetchCache = (revalidateInSeconds: number): NextFetchRequestInit => ({
  cache: 'force-cache',
  next: { revalidate: revalidateInSeconds },
});
